import React, { useState, useRef, useEffect } from "react"
import styled, { keyframes } from "styled-components"
import { IconReaction } from "./Icons"

const reactions = [
    { emoji: "🚀", name: "cohete" },
    { emoji: "🏆", name: "trofeo" },
    { emoji: "🥇", name: "medalla" },
    { emoji: "💪", name: "fuerza" },
    { emoji: "👏", name: "aplauso" },
    { emoji: "🙌", name: "manos arriba" },
    { emoji: "🙏", name: "oracion" },
]

const ReactionButton = ({ onReact, disabled = false, disabledTitle = "" }) => {
    const [visible, setVisible] = useState(false)
    const containerRef = useRef(null)

    const toggleReactions = () => {
        if (disabled) return
        setVisible(prev => !prev)
    }

    const handleClickOutside = e => {
        if (containerRef.current && !containerRef.current.contains(e.target)) {
            setVisible(false)
        }
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside)
        return () => document.removeEventListener("mousedown", handleClickOutside)
    }, [])

    return (
        <Wrapper ref={containerRef}>
            <TriggerButton onClick={toggleReactions} disabled={disabled} aria-disabled={disabled}>
                <IconReaction width="20" height="20" color={disabled ? "#9ca3af" : "#ff0102"} />
            </TriggerButton>

            {visible && !disabled && (
                <Popover>
                    {reactions.map(({ emoji, name }) => (
                        <EmojiButton
                            key={name}
                            onClick={() => {
                                onReact({ emoji, name })
                                setVisible(false)
                            }}
                            title={name}
                        >
                            {emoji}
                        </EmojiButton>
                    ))}
                </Popover>
            )}
        </Wrapper>
    )
}

export default ReactionButton

/* ========== Styled Components ========== */

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(5px); }
  to { opacity: 1; transform: translateY(0); }
`

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items:center;
  justify-content:center;
`

const TriggerButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  // padding: 0 4px;
  // position: relative;
  // top: 0px;
  outline: none;
  padding: 0;

  svg {
    transition: transform 0.15s ease;
  }

  &:hover svg {
    transform: scale(1.1);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }

  &:disabled:hover svg {
    transform: none;
  }
`

const Popover = styled.div`
  position: absolute;
  bottom: 30px;
  right: 0;
  display: flex;
  gap: 6px;
  padding: 6px 10px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 100;
  animation: ${fadeIn} 0.2s ease;
`

const EmojiButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  outline: none;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.2);
  }
`
